/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:07.031
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentHouseSalesCardConsume,
	getRentHouseSalesCardConsumeCreateInit,
	getRentHouseSalesCardConsumeEditInit,
	getRentHouseSalesCardConsumeView,
	deleteRentHouseSalesCardConsume
} from '@api/rentmanage/RentHouseSalesCardConsume';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentHouseSalesCardConsumeCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesCardConsumeCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseSalesCardConsumeEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesCardConsumeEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseSalesCardConsume({}, RentHouseSalesCardConsume) {
			return new Promise((resolve, reject) => {
				saveRentHouseSalesCardConsume(RentHouseSalesCardConsume)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseSalesCardConsumeView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesCardConsumeView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseSalesCardConsume({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseSalesCardConsume({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
